import {
  DxCard,
  DxCardContent,
  DxCardHeader,
  DxList,
  DxContainer,
} from '@dvag/design-system-react';
import { useParams } from 'react-router-dom';

import { Item } from 'component/BottomCards/Card/Item';

import { BALANCE_SHEET, leftCardSections } from './pages.config';

export const LeftCard = ({ showBalanceSheet = false }: { showBalanceSheet?: boolean }) => {
  const { householdId } = useParams();

  const leftCardSectionsFiltered = leftCardSections.filter((section) =>
    section.id === BALANCE_SHEET ? showBalanceSheet : true,
  );

  return (
    <DxCard data-testid="left-card">
      <DxCardHeader label="Allfinanzinhalte" />
      <DxCardContent className="dashboard-card-content">
        <DxContainer className="flex column">
          <DxList size="m">
            {leftCardSectionsFiltered.map(({ icon, id, title, navigate, contentIcon }) => (
              <Item
                id={id}
                key={id}
                title={title}
                icon={icon}
                onItemClick={() => navigate(householdId as string)}
                contentIcon={contentIcon}
              />
            ))}
          </DxList>
        </DxContainer>
      </DxCardContent>
    </DxCard>
  );
};
